/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Object3D } from 'three';
/**
 * Abstract Editor for GizmoKit
 * do not implement anything here
 */
export class Editor extends Object3D {
}
//# sourceMappingURL=Editor.js.map